import Users from '../components/Users';
import {graphql} from 'react-apollo';
import gql from 'graphql-tag';
import {SimpleUser} from '../qql-shared/fragments';
import {USER_STATUS_NEW, USER_STATUS_ACTIVE, USER_STATUS_INACTIVE} from '../constants/userConstants';

const userCountQuery = status => `${status}UserCount: userCount(status: ${status})`;

const UsersQuery = gql`
  query allUsers($status: UserStatus) {
    allUsers(status: $status) {
      ...SimpleUser
      phone
      role
    }
    ${userCountQuery(USER_STATUS_NEW)}
    ${userCountQuery(USER_STATUS_ACTIVE)}
    ${userCountQuery(USER_STATUS_INACTIVE)}
  }
  ${SimpleUser}
`;

const UsersQueryConfig = {
  options: {variables: {status: USER_STATUS_ACTIVE}}
};

export default graphql(UsersQuery, UsersQueryConfig)(Users);



// WEBPACK FOOTER //
// ./src/containers/UsersPage.js